import * as React from 'react';
import * as ReactDom from 'react-dom';
import * as Exceljs from '../../actions/ExportToExcel.js';
import { EmailControlExcel } from './../sharedcomponents/EmailControlExcel';
import { PopupWindow } from './../sharedcomponents/PopupWindow';
import { GridPreferenceControl } from './../sharedcomponents/GridPreferenceControl';
import { GridColumnPreferences } from './../sharedcomponents/GridColumnPreferences';
import $ from 'jquery';

import { TemperatureGraph } from '../childcomponents/TemperatureGraph';
import { GensetMonitorGraph } from '../childcomponents/GensetMonitorGraph';
import { ExportToExcelConfirmationWindow } from '../sharedcomponents/ExportToExcelConfirmationWindow';
import { EmailControlExcelPreference } from '../sharedcomponents/EmailControlExcelPreference';
import Select from 'react-select';
import forEach from 'lodash/forEach';
import Workbook from 'react-excel-workbook';


var Excel = Exceljs.default;


interface ToolBarState {
    renderEmailHtml: any;
    renderGridPreferenceHtml: any;
    temperatureGraphHtml: any;
    gensetMonitoringGraphHtml: any;
    modelDialogHtml: any;
    exportFields: ExportFields;
    excelData: any[];
    headerData: any[];
    isDownload: boolean;
    excelGridData: any[];
    formName: string;
    fileTitle: string;
    sheetInfo: any;
    renderExportToExcelHTML: any; 
    selectedheaderName: string;
    isClearable: boolean;
    AllColumns: any[];
    PrevGroupId: number;
    PrevColId: string;
}

class ReeferHistoryFilter {
    FromDate: string;
    ToDate: string;
    Units: string;
}
class ExportFields {
    ExportData: string;
}

var self;

export class GridToolBarExcel extends React.Component<any, ToolBarState> {
    constructor(props: any) {
        super(props);
        var filterSet = new ReeferHistoryFilter();
        var exportData = new ExportFields();
        this.state = {
            renderEmailHtml: '', modelDialogHtml: '', temperatureGraphHtml: '', gensetMonitoringGraphHtml: '', exportFields: exportData, excelData: [], headerData: [], isDownload: false,
            excelGridData: this.props.gridData, formName: this.props.formName, fileTitle: this.props.formName, sheetInfo: '', renderGridPreferenceHtml: '', renderExportToExcelHTML: '',
            selectedheaderName: null, isClearable: true, AllColumns: [], PrevGroupId: -1, PrevColId: null
        };
        self = this;
    }

    componentDidMount() {
        this.renderSheets();
    }

    renderEmailControl() {
        if (this.props.functionId != undefined && this.props.functionId != null && this.props.functionId > 0) {
            //new control - which has preference

            return <EmailControlExcelPreference reeferStatusResult={this.props.gridData} columnDefinition={this.props.colDefs} colDefs2={this.props.colDefs2} parentchild={this.props.parentchild}
                formName={this.props.formName} FunctionID={this.props.functionId} widgetId={this.props.widgetId} gridApiParams={this.props.gridApiParams}
                    dashboardWidgetsSearch={this.props.dashboardWidgetsSearch} dashboardPreferenceId = {this.props.dashboardPreferenceId}
                    isIncludeRowGroup={this.props.gridApiParams.gridOptionsWrapper == undefined
                    && this.props.gridApiParams.gridOptionsWrapper == null ? false :
                    this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false} sensorData={this.props.sensorData} isMapHistory={this.props.isHistory} //RCNG-1584
            />;

        }
        else {
            //no preference form support
            return <EmailControlExcel reeferStatusResult={this.props.gridData} columnDefinition={this.props.colDefs} parentchild={this.props.parentchild} formname={this.props.formName} />;
        }
    }

    renderGridPreferenceControl(functionId: any, widgetId: any) {
        //if (this.props.formName == "ReeferGrid" || this.props.formName == "ReeferHistory" || this.props.formName == "ReeferMapGrid")
        //    return <GridPreferenceControl formname={this.props.formName} functionId={functionId} gridApiParams={this.props.gridApiParams} closeModelDialog={this.closeToolBarGridPreferenceModel.bind(this)}></GridPreferenceControl>;
        //else
            return <GridColumnPreferences formname={this.props.formName} functionId={functionId} dashboardPreferenceId = {this.props.dashboardPreferenceId} widgetId={widgetId} dashboardWidgetsSearch={this.props.dashboardWidgetsSearch}
             revisionNum={this.props.revisionNum} gridApiParams={this.props.gridApiParams} validateRevisionNum={this.props.validateRevisionNum.bind(this)} refreshRevisionNum={this.props.refreshRevisionNum.bind(this)} closeModelDialog={this.closeToolBarGridPreferenceModel.bind(this)}></GridColumnPreferences>;
            
    }

    renderETEConfirmationWindowControl() {

        return <ExportToExcelConfirmationWindow formName={this.props.formName} functionId={this.props.functionId} widgetId={this.props.widgetId} gridApiParams={this.props.gridApiParams}
            gridData={this.props.gridData} colDefs={this.props.colDefs} colDefs2={this.props.colDefs2} parentchild={this.props.parentchild} dashboardWidgetsSearch={this.props.dashboardWidgetsSearch}
            dashboardPreferenceId = {this.props.dashboardPreferenceId} IsServerSideEnabled={this.props.IsServerSideEnabled}
            closeModelDialog={this.closeToolBarGridExportToExcelPreference.bind(this)} sensorData={this.props.sensorData} isMapHistory={this.props.isHistory}></ExportToExcelConfirmationWindow>; //RCNG-1584

    }

    renderTempratureGraphHtml() {
        return <TemperatureGraph reeferHistoryData={this.props.gridData} propsReeferFormatters={this.props.reeferFormatter} historySearchFilters={this.props.filterParams}></TemperatureGraph>
    }

    renderGensetMonitoringGraph() {
        return <GensetMonitorGraph gensetHistoryData={this.props.gridData} gensetHistoryFilters={this.props.filterParams}></GensetMonitorGraph>
    }

    modelDialogGensetGraphHtml() {
        return <div className="modal sendEmail-position" role="dialog" id={"GensetGraph_" + this.props.formName} style={{ right: (this.props.formName == 'PTResultGrid') ? 'auto' : 0 }}>
            <div className="modal-dialog modal-lg TempGraph">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Genset Monitoring Data - {this.props.gensetId}</h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={this.closeToolBarGensetGraphModel.bind(this)}><span aria-hidden="true">&times;</span></button>
                       
                    </div>
                    <div className="modal-body">
                        {this.state.gensetMonitoringGraphHtml}
                    </div>
                </div>
            </div>
        </div>
    }

    modelDialogTempGraphHtml() {
        return <div className="modal sendEmail-position" role="dialog" id={"TempGraph_" + this.props.formName} style={{ right: (this.props.formName == 'PTResultGrid') ? 'auto' : 0 }}>
            <div className="modal-dialog modal-lg TempGraph">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">Reefer Monitoring Data - {this.props.reeferId}</h4>
                        <button type="button" className="btn-close" aria-label="Close" onClick={this.closeToolBarTempGraphModel.bind(this)}><span aria-hidden="true">&times;</span></button>
                       
                    </div>
                    <div className="modal-body">
                        {this.state.temperatureGraphHtml}
                    </div>
                </div>
            </div>
        </div>
    }

    modelDialogEmailHtml() {
        return <div className="modal" role="dialog" id={this.props.formName} style={{ right: (this.props.formName == 'PTResultGrid') ? 'auto' : 0 }}>
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Email</h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={this.closeToolBarModel.bind(this)}><span aria-hidden="true">&times;</span></button>
                        
                    </div>
                    <div className="modal-body">
                        {this.state.renderEmailHtml}
                    </div>
                </div>
            </div>
        </div>
    }

    modelDialogGridPreferenceHtml() {
        return <div className={"DragandDropControlUI modal"} role="dialog" id={"StatusGrid_" + this.props.formName} style={{ right: (this.props.formName == 'PTResultGrid') ? 'auto' : 0 }}>
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Grid Preference</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.closeToolBarGridPreferenceModel.bind(this)}><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div className="modal-body">
                        {this.state.renderGridPreferenceHtml}
                    </div>
                </div>
            </div>
        </div>
    }

    modelDialogExportToExcelHtml() {
        return <div className="modal" role="dialog" id={"DashboardStatus_" + this.props.formName} style={{ right: (this.props.formName == 'PTResultGrid') ? 'auto' : 0 }}>
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Export To Excel</h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={this.closeToolBarGridExportToExcelPreference.bind(this)}><span aria-hidden="true">&times;</span></button>                       
                    </div>
                    <div className="modal-body">
                        {this.state.renderExportToExcelHTML}
                    </div>
                </div>
            </div>
        </div>
    }


    RefreshData() {
        this.props.refreshGrid();
    }

    ExportToExcel() {
        //this.props.exportToExcel();  
        var arrData;
        if (this.props.gridData != undefined && this.props.gridData != null && this.props.gridData.length > 0) {
            arrData = typeof this.props.gridData != 'object' ? JSON.parse(this.props.gridData) : this.props.gridData;
            $("#globalLoader").show();
            //WI-21469 - start
            if (arrData.length > 0) {
                var i;
                var valueString = "";
                for (i = 0; i < arrData.length; i++) {
                    if (arrData[i].RunningMode != 'undefined' && arrData[i].RunningMode != null) {
                        var inputValue = arrData[i].RunningMode;

                        if (inputValue != null && inputValue != undefined && inputValue != '') {
                            valueString = inputValue.replace('/^\s+/g', '');
                            if (valueString.startsWith(",")) {
                                valueString = valueString.substring(1, valueString.length);
                            }

                            if (valueString.endsWith(",")) {
                                valueString = valueString.substring(0, valueString.length - 1);
                            }

                            if (valueString != "") {
                                arrData[i].RunningMode = valueString;
                            }
                        }
                    }
                }
            }
            //WI-21469 - end

            var r = this.props.colDefs;
            var uri;
            var sheetData = { HeaderData: [], ColumnData: [] };

            if (this.props.parentchild == 'P') {
                // Excel.InitializeExportParent(arrData, r, this.props.formName);
                uri = Excel.InitializeExportParentGridExportToXLSX(arrData, r, this.props.formName);
                this.state.exportFields.ExportData = JSON.stringify(uri);
            } else {
                // Excel.InitializeExportParent(arrData, r, this.props.formName);
                uri = Excel.InitializeChildGridExportToExcel(arrData, r, this.props.formName);
                this.state.exportFields.ExportData = JSON.stringify(uri);
            }

            sheetData = Excel.ConvertCSVToJSon(uri);
            this.setState({ excelData: sheetData.ColumnData, headerData: sheetData.HeaderData }, () => this.downloadExcel(this.props.formName, true));
        }
        else {
            $("#globalLoader").hide();
            PopupWindow.showErrorMessage("Alert", "No Data to Export.");
        }
    }

    closeToolBarModel() {
        $('#' + this.props.formName).hide();
    }

    closeToolBarGridPreferenceModel() {
        $('#StatusGrid_' + this.props.formName).hide();
    }

    closeToolBarTempGraphModel() {
        $('#TempGraph_' + this.props.formName).hide();
    }

    closeToolBarGensetGraphModel() {
        $('#GensetGraph_' + this.props.formName).hide();
    }
    closeToolBarGridExportToExcelPreference() {
        $('#DashboardStatus_' + this.props.formName).hide();
    }


    EmailTo() {
        EmailControlExcelPreference.ClearFilters();
        if (this.props.gridData != undefined && this.props.gridData != null && this.props.gridData.length > 0) {
            if (this.props.formName == "ReeferStatusGrid" || this.props.formName == "ReeferHistoryGrid" || this.props.formName == "PTResultGrid") {
                this.props.renderEmailDialog(this.props.gridData, this.props.colDefs, this.props.formName, this.props.parentchild,
                this.props.functionId, this.props.widgetId, this.props.gridApiParams,
                    this.props.gridApiParams.gridOptionsWrapper == undefined
                        && this.props.gridApiParams.gridOptionsWrapper == null ? false :
                        this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false, this.props.sensorData);
            }
            else {
                this.setState({ renderEmailHtml: this.renderEmailControl() });
                $('#' + this.props.formName).show();
            }
        }
        else {
            PopupWindow.showErrorMessage("Alert", "No Data to Email.");
        }
    }

    GridPreference(functionId: any, widgetId: any) {
        this.setState({ renderGridPreferenceHtml: this.renderGridPreferenceControl(functionId, widgetId) });
        $('#StatusGrid_' + this.props.formName).show();
    }

    ExportToExcelNew(functionId: any) {
        ExportToExcelConfirmationWindow.clearOptionFilters();
        if (this.props.gridData != undefined && this.props.gridData != null && this.props.gridData.length > 0) {
            if (this.props.formName == "ReeferStatusGrid") {
                this.props.renderExportToExcelDialog(functionId, this.props.widgetId, this.props.gridApiParams, this.props.formName, this.props.gridData,
                    this.props.colDefs, this.props.parentchild, this.props.sensorData);
            }
            else {
                this.setState({ renderExportToExcelHTML: this.renderETEConfirmationWindowControl() });
                $('#DashboardStatus_' + this.props.formName).show();
            }
        }
        else {
            PopupWindow.showErrorMessage("Alert", "No Data to Export.");
        }
    }

    openTemperatureGraph() {
        if (this.props.gridData.length > 0) {
            this.setState({ temperatureGraphHtml: this.renderTempratureGraphHtml() });
            $('#TempGraph_' + this.props.formName).show();
        }
        else
            PopupWindow.showErrorMessage("Alert", "No data to draw graph");
    }

    openGensetMonitoringGraph() {
        if (this.props.gridData.length > 0) {
            this.setState({ gensetMonitoringGraphHtml: this.renderGensetMonitoringGraph() });
            $('#GensetGraph_' + this.props.formName).show();
        }
        else
            PopupWindow.showErrorMessage("Alert", "No data to draw graph");
    }

    renderSheets() {
        this.setState({ sheetInfo: this.generateSheetInfo() }, () => this.checkToFileDownload());
    }

    checkToFileDownload() {
        if (this.state.isDownload) {
            $('#btnDownloadExcel').click();
            $("#globalLoader").hide();
            PopupWindow.showErrorMessage("Alert", "Data exported successfully.");
            this.setState({ isDownload: false });
        }
    }

    getSheetInfo(headerName: string) {
        var headerInfo = headerName.replace(/\s+/g, '');
        var removeDotInHeader = headerInfo.split('.').join('');
        var removeNInHeader = removeDotInHeader.replace('/n', '');
        var removeHashInHeader = removeNInHeader.replace('#', '');
        var removeUTCInHeader = removeHashInHeader.replace('(UTC)', '');
        var finalHeaderColumn = removeUTCInHeader.replace('(°C)', '');
        return <Workbook.Column label={headerName} value={finalHeaderColumn} />;
    }

    generateSheetInfo() {
        var columnInfo = [];
        if (this.state.headerData != null && this.state.headerData.length > 0) {
            $.each(this.state.headerData, function (i, iVal) {
                var sheetObject = self.getSheetInfo(iVal.headerName);
                columnInfo.push(sheetObject);
            });
        }

        return <Workbook.Sheet data={this.state.excelData} name="Sheet1">
            {columnInfo}
        </Workbook.Sheet>;
    }

    downloadExcel(formName: string, isFileDownload: boolean) {
        var currentDate = new Date();
        self.setState({
            fileTitle: formName + currentDate.getDate() + currentDate.getMonth() + currentDate.getFullYear() + currentDate.getHours() + currentDate.getMinutes() + currentDate.getSeconds(),
            isDownload: isFileDownload
        }, () => self.renderSheets());
    }

    static applySheetData(sheetData: any, formName: string) {
        self.setState({ excelData: sheetData.ColumnData, headerData: sheetData.HeaderData }, () => self.downloadExcel(formName == '' ? self.props.formName : formName, true));
    }

    ClearQuickFilter() {
        $("#GridExcelFilter").val('');
        this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.setQuickFilter('');
    }

    onQuickFilterChanged(event: any) {
        this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.setQuickFilter(event.target.value);
    }
    ColumnChange(event: any) {
        if (event != null) {
            var name: string = event.value;
            this.setState({
                selectedheaderName: name
            });
            var defaultKeys = this.state.AllColumns.filter(x => x.colDef.headerName == name);
            var colId = defaultKeys[0].colId;
            if (this.state.PrevGroupId != -1) {
                this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnGroupOpened(this.state.PrevGroupId, false);
            }
            if (this.state.PrevColId != null) {
                this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.getColumnDef(this.state.PrevColId).headerClass = '';
                this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.refreshHeader();
            }
            if (defaultKeys.length > 0 && defaultKeys[0].colDef.columnGroupShow == "open") {
                this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.getColumnDef(colId).headerClass = "ColumHighlightBg";
                this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.refreshHeader();
                
                this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnGroupOpened(defaultKeys[0].parent.groupId, true);
                //this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.onGroupExpandedOrCollapsed();
                setTimeout(() => {
                    this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.ensureColumnVisible(colId, 'middle');//RCNG-2543
                }, 200);
                this.setState({ PrevGroupId: defaultKeys[0].parent.groupId, PrevColId: colId });
            }
            else {
                this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.getColumnDef(colId).headerClass = "ColumHighlightBg";
                this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.refreshHeader();
                
                this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.ensureColumnVisible(colId, 'middle');//RCNG-2543
                this.setState({ PrevGroupId: -1, PrevColId: colId });
            }
        }
        else {
            this.setState({
                selectedheaderName: null
            });
            if (this.state.PrevGroupId != -1) {
                this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnGroupOpened(this.state.PrevGroupId, false);
            }
            if (this.state.PrevColId != null) {
                this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.getColumnDef(this.state.PrevColId).headerClass = '';
                this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.refreshHeader();
            }
        }
    }
    static GetColumns(params: any) {
        var newColumns = [];
        var Displayedcolumns = params.columnApi.getAllDisplayedColumnGroups();
        forEach(Displayedcolumns, function (value, key) {
            forEach(value.children, function (bv, bk) {
                newColumns.push(bv);
            });
        });
        self.setState({ AllColumns: newColumns })
    }
    public render() {
        //var enableGridPreference = JSON.parse(sessionStorage.getItem('UserInfo')).IsCustomAttributesEnable;
        var gridPrefCss = 'btn btn-outline-secondary';
        //if (enableGridPreference)
        //    gridPrefCss = 'btn btn-default hide';
        var readOnly :any = this.props.isReadOnly;
        if(readOnly == true)
            gridPrefCss = 'btn btn-outline-secondary disabled';

        if (this.props.formName == "ReeferGrid" || this.props.formName == "ReeferHistory" || this.props.formName == "GensetStatus" || this.props.formName == "GensetHistory") {
            if (this.state.AllColumns != null && this.state.AllColumns.length > 0) {
                var Alldisplayedcolumns = this.state.AllColumns;

                if (Alldisplayedcolumns != undefined && Alldisplayedcolumns != null && Alldisplayedcolumns.length > 0) {
                    var Selectedcolumns = Alldisplayedcolumns.map(function (Columns) {
                        return (
                            { value: Columns.colDef.headerName, label: Columns.colDef.headerName }
                        );
                    });
                }
            }
        }
        return <div className='d-flex'>
           
                <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                    <button type="button" id="hidePopUpBtn" title='Refresh' className="btn btn-outline-secondary" onClick={this.RefreshData.bind(this)} ><span className='fas fa-sync-alt'></span></button>

                    {this.props.formName == "ReeferGrid" || this.props.formName == "GensetStatus" || this.props.formName == "DryStatus" || this.props.formName == "ChassisStatus"
                        || this.props.formName == "ReeferHistory" || this.props.formName == "GensetHistory" || this.props.formName == "DryHistory" || this.props.formName == "ChassisHistory"
                        || this.props.formName == "ReeferMapGrid" || this.props.formName == "GensetMap" || this.props.formName == "DryMap" || this.props.formName == "ChassisMap"
                    ?
                        <button type="button" id="hidePopUpBtn" title='Export to Excel' data-bs-toggle="modal" className="btn btn-outline-secondary" onClick={this.ExportToExcelNew.bind(this)}><span className='far fa-file-excel'></span></button>
                        :
                        <button type="button" id="hidePopUpBtn" title='Export to Excel' data-bs-toggle="modal" className="btn btn-outline-secondary" onClick={this.ExportToExcel.bind(this)}><span className='far fa-file-excel'></span></button>
                    }

                    <button type="button" id="hidePopUpBtn" title='Email to' className="btn btn-outline-secondary" onClick={this.EmailTo.bind(this)}><span className='fa fa-envelope'></span></button>

                    {this.props.formName == "ReeferHistory" ?
                        <button type="button" id="hidePopUpBtnChart" disabled={this.props.disableFlag} title='Reefer Monitoring Data' className="btn btn-outline-secondary" onClick={this.openTemperatureGraph.bind(this)}><span className='fas fa-chart-bar'></span></button> : ""}
                    {this.props.formName == "GensetHistory" ?
                        <button type="button" id="hidePopUpBtnChart" title='Genset Monitoring Data' className="btn btn-outline-secondary" onClick={this.openGensetMonitoringGraph.bind(this)}><span className='fas fa-chart-bar'></span></button> : ""}

                    {this.props.formName == "ReeferGrid" ?
                        <button type="button" id="hidePopUpBtn" title='Grid Preference' className={gridPrefCss} data-bs-toggle="modal" onClick={this.GridPreference.bind(this, 41, 4)}><span className='fa fa-th'></span></button> : ""}
                    {this.props.formName == "ReeferHistory" || this.props.formName == "ReeferMapGrid" || this.props.formName == "ReeferDetailsHistory" ?
                        <button type="button" id="hidePopUpBtn" title='Grid Preference' className="btn btn-outline-secondary " data-bs-toggle="modal" onClick={this.GridPreference.bind(this, 42, 5)}><span className='fa fa-th'></span></button> : ""}
                    {this.props.formName == "GensetStatus" ?
                        <button type="button" id="hidePopUpBtn" title='Grid Preference' className={gridPrefCss} data-bs-toggle="modal" onClick={this.GridPreference.bind(this, 46, 12)}><span className='fa fa-th'></span></button> : ""}
                    {this.props.formName == "GensetHistory" || this.props.formName == "GensetMap" || this.props.formName == "GensetDetailsHistory" ?
                        <button type="button" id="hidePopUpBtn" title='Grid Preference' className="btn btn-outline-secondary " data-bs-toggle="modal" onClick={this.GridPreference.bind(this, 47, 13)}><span className='fa fa-th'></span></button> : ""}
                    {this.props.formName == "DryStatus" ?
                        <button type="button" id="hidePopUpBtn" title='Grid Preference' className={gridPrefCss} data-bs-toggle="modal" onClick={this.GridPreference.bind(this, 48, 16)}><span className='fa fa-th'></span></button> : ""}
                    {this.props.formName == "DryHistory" || this.props.formName == "DryMap" || this.props.formName == "DryDetailsHistory" ?
                        <button type="button" id="hidePopUpBtn" title='Grid Preference' className="btn btn-outline-secondary " data-bs-toggle="modal" onClick={this.GridPreference.bind(this, 49, 17)}><span className='fa fa-th'></span></button> : ""}
                    {this.props.formName == "ChassisStatus" ?
                        <button type="button" id="hidePopUpBtn" title='Grid Preference' className={gridPrefCss} data-bs-toggle="modal" onClick={this.GridPreference.bind(this, 61, 20)}><span className='fa fa-th'></span></button> : ""}
                    {this.props.formName == "ChassisHistory" || this.props.formName == "ChassisMap" || this.props.formName == "ChassisDetailsHistory" ?
                        <button type="button" id="hidePopUpBtn" title='Grid Preference' className="btn btn-outline-secondary " data-bs-toggle="modal" onClick={this.GridPreference.bind(this, 62, 21)}><span className='fa fa-th'></span></button> : ""}

                    <Workbook filename={this.state.fileTitle + ".xlsx"} element={<button id="btnDownloadExcel" className="btn btn-lg btn-primary d-none"></button>}>
                        {this.state.sheetInfo}
                    </Workbook>
                </div>
           

            {this.props.formName == "ReeferGrid" || this.props.formName == "GensetStatus" || this.props.formName == "ChassisStatus" ?
                <div className={this.props.formName == "ReeferGrid" ? 'QuickFilterReeferStatus' : this.props.formName == "GensetStatus" ? 'QuickFilterGensetStatus' : 'QuickFilterStatus'}>
                    <input type='text' id='GridExcelFilter' name="focus" className='form-control' placeholder='Quick Filter' title='Enter a value to filter the grid below. The value will be compared to all fields.' onChange={e => this.onQuickFilterChanged(e)} required />
                    <button type="reset" className="close-icon" onClick={this.ClearQuickFilter.bind(this)}></button>
                </div> : ""}
            {
                this.props.formName == "ReeferGrid" || this.props.formName == "GensetStatus" ?
                    <div className={this.props.formName == "GensetStatus" ? "GensetColumnControl grid-select-control" : "ReeferColumnControl grid-select-control"}>
                        <Select
                            value={this.state.selectedheaderName}
                            onChange={this.ColumnChange.bind(this)}
                            options={Selectedcolumns}
                            placeholder="Find Column"
                            removeSelected={this.state.isClearable}
                        />
                    </div>
                    :
                    this.props.formName == "ReeferHistory" || this.props.formName == "GensetHistory"?
                        <div className="ReeferColumnHistoryControl grid-select-control">
                            <Select
                                value={this.state.selectedheaderName}
                                onChange={this.ColumnChange.bind(this)}
                                options={Selectedcolumns}
                                placeholder="Find Column"
                                className='form-select-sm'
                                removeSelected={this.state.isClearable}
                            />
                        </div> :
                        ""
            }
            {this.modelDialogEmailHtml()}
            {this.modelDialogGridPreferenceHtml()}
            {this.modelDialogTempGraphHtml()}
            {this.modelDialogGensetGraphHtml()}
            {this.modelDialogExportToExcelHtml()}
        </div>
    }
}